import { render, staticRenderFns } from "./frmterms.vue?vue&type=template&id=082ef5fc&"
import script from "./frmterms.vue?vue&type=script&lang=js&"
export * from "./frmterms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default})
